import Navbar from "./Navbar";
import Hero from "./Hero";
import Marquee from "./Marquee";
import Stats from "./Stats";
import Services from "./Services";
import WhyUs from "./WhyUs";
import Process from "./Process";
import Portfolio from "./Portfolio";
import VideoSection from "./VideoSection";
import Testimonials from "./Testimonials";
import Founder from "./Founder";
import Materials from "./Materials";
import Calculator from "./Calculator";
import Visualizer from "./Visualizer";
import Styles from "./Styles";
import FAQ from "./FAQ";
import Contact from "./Contact";
import Footer from "./Footer";
import { LeadTriggers, FloatingUI } from "./LeadPopup";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Stats />
      <Services />
      <WhyUs />
      <Process />
      <Portfolio />
      <VideoSection />
      <Testimonials />
      <Founder />
      <Materials />
      <Calculator />
      <Visualizer />
      <Styles />
      <FAQ />
      <Contact />
      <Footer />
      <LeadTriggers />
      <FloatingUI />
    </main>
  );
}
